/*options-table*/
/*caching*/
/*messages*/
/*task-running-and-logs*/
/*environment-variables*/
/*debugging-outputs*/
/*authentication*/
/*other*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "选项概述",
  "description": "Turborepo 的标志、配置和系统环境变量"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "有三种方法可以管理 turbo 调用的行为："
  }, {
    "heading": "",
    "content": "¥There are three ways to manage the behavior of a turbo invocation:"
  }, {
    "heading": "",
    "content": "turbo.json 中的配置"
  }, {
    "heading": "",
    "content": "¥Configuration in turbo.json"
  }, {
    "heading": "",
    "content": "系统环境变量"
  }, {
    "heading": "",
    "content": "¥System Environment Variables"
  }, {
    "heading": "",
    "content": "传递给 CLI 调用的标志"
  }, {
    "heading": "",
    "content": "¥Flags passed to the CLI invocation"
  }, {
    "heading": "",
    "content": "上面列出的三种策略按优先顺序排列。如果提供了标志值，则对于相同的系统环境变量或 turbo.json 配置，将使用该标志的值。因此，我们建议使用："
  }, {
    "heading": "",
    "content": "¥The three strategies listed above are in order of precedence. Where a flag value is provided, for the same System Environment Variable or turbo.json configuration, the value for the flag will be used. Because of this, we recommend using:"
  }, {
    "heading": "",
    "content": "turbo.json 默认配置"
  }, {
    "heading": "",
    "content": "¥turbo.json configuration for defaults"
  }, {
    "heading": "",
    "content": "用于每个环境覆盖的系统环境变量"
  }, {
    "heading": "",
    "content": "¥System Environment Variables for per-environment overrides"
  }, {
    "heading": "",
    "content": "每次调用覆盖的标志"
  }, {
    "heading": "",
    "content": "¥Flags for per-invocation overrides"
  }, {
    "heading": "选项表-options-table",
    "content": "¥Options table"
  }, {
    "heading": "缓存-caching",
    "content": "¥Caching"
  }, {
    "heading": "缓存-caching",
    "content": "行为"
  }, {
    "heading": "缓存-caching",
    "content": "标志"
  }, {
    "heading": "缓存-caching",
    "content": "环境变量"
  }, {
    "heading": "缓存-caching",
    "content": "turbo.json"
  }, {
    "heading": "缓存-caching",
    "content": "强制运行任务"
  }, {
    "heading": "缓存-caching",
    "content": "--force"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_FORCE"
  }, {
    "heading": "缓存-caching",
    "content": "cache"
  }, {
    "heading": "缓存-caching",
    "content": "远程缓存超时"
  }, {
    "heading": "缓存-caching",
    "content": "--remote-cache-timeout"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_REMOTE_CACHE_TIMEOUT"
  }, {
    "heading": "缓存-caching",
    "content": "remoteCache.timeout"
  }, {
    "heading": "缓存-caching",
    "content": "远程缓存上传超时"
  }, {
    "heading": "缓存-caching",
    "content": "*"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
  }, {
    "heading": "缓存-caching",
    "content": "remoteCache.uploadTimeout"
  }, {
    "heading": "缓存-caching",
    "content": "缓存签名密钥"
  }, {
    "heading": "缓存-caching",
    "content": "*"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
  }, {
    "heading": "缓存-caching",
    "content": "signature"
  }, {
    "heading": "缓存-caching",
    "content": "预检请求"
  }, {
    "heading": "缓存-caching",
    "content": "--preflight"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_PREFLIGHT"
  }, {
    "heading": "缓存-caching",
    "content": "remoteCache.preflight"
  }, {
    "heading": "缓存-caching",
    "content": "远程缓存基准 URL"
  }, {
    "heading": "缓存-caching",
    "content": "*"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_API"
  }, {
    "heading": "缓存-caching",
    "content": "remoteCache.apiUrl"
  }, {
    "heading": "缓存-caching",
    "content": "缓存源"
  }, {
    "heading": "缓存-caching",
    "content": "--cache"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_CACHE"
  }, {
    "heading": "缓存-caching",
    "content": "*"
  }, {
    "heading": "缓存-caching",
    "content": "本地缓存目录"
  }, {
    "heading": "缓存-caching",
    "content": "--cache-dir"
  }, {
    "heading": "缓存-caching",
    "content": "TURBO_CACHE_DIR"
  }, {
    "heading": "缓存-caching",
    "content": "cacheDir"
  }, {
    "heading": "消息-messages",
    "content": "¥Messages"
  }, {
    "heading": "消息-messages",
    "content": "行为"
  }, {
    "heading": "消息-messages",
    "content": "标志"
  }, {
    "heading": "消息-messages",
    "content": "环境变量"
  }, {
    "heading": "消息-messages",
    "content": "turbo.json"
  }, {
    "heading": "消息-messages",
    "content": "禁用版本打印"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "TURBO_PRINT_VERSION_DISABLED"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "禁用遥测消息"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "TURBO_TELEMETRY_MESSAGE_DISABLED"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "禁用全局 turbo 警告"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "TURBO_GLOBAL_WARNING_DISABLED"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "不支持更新通知程序"
  }, {
    "heading": "消息-messages",
    "content": "*"
  }, {
    "heading": "消息-messages",
    "content": "TURBO_NO_UPDATE_NOTIFIER"
  }, {
    "heading": "消息-messages",
    "content": "noUpdateNotifier"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "¥Task running and logs"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "行为"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "标志"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "环境变量"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "turbo.json"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "终端 UI"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--ui"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "TURBO_UI"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "ui"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "运行受影响的任务"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--affected"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "禁用包管理器检查"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--dangerously-disable-package-manager-check"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "dangerouslyDisablePackageManagerCheck"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "受影响的基引用"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "TURBO_SCM_BASE"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "受影响的头引用"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "TURBO_SCM_HEAD"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "仅运行直接指定的任务"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--only"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "任务并发度"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--concurrency"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "TURBO_CONCURRENCY"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "任务日志顺序"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--log-order"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "TURBO_LOG_ORDER"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "当前工作目录"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--cwd"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "流日志前缀"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--log-prefix"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "任务日志输出级别"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--output-logs-option"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "outputLogs"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "全局输入"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--global-deps"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "globalDependencies"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "终端颜色"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "--color"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "FORCE_COLOR"
  }, {
    "heading": "任务运行和日志-task-running-and-logs",
    "content": "*"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "¥Environment variables"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "行为"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "标志"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "环境变量"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "turbo.json"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "环境变量模式"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "--env-mode"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "*"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "envMode"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "供应商环境变量"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "*"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "TURBO_CI_VENDOR_ENV_KEY"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "*"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "框架变量异常"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "--framework-inference"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "*"
  }, {
    "heading": "环境变量-environment-variables",
    "content": "*"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "¥Debugging outputs"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "行为"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "标志"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "环境变量"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "turbo.json"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "运行摘要"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "--summarize"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "TURBO_RUN_SUMMARY"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "*"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "图形可视化"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "--graph"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "*"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "*"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "试运行"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "--dry"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "*"
  }, {
    "heading": "调试输出-debugging-outputs",
    "content": "*"
  }, {
    "heading": "身份验证-authentication",
    "content": "¥Authentication"
  }, {
    "heading": "身份验证-authentication",
    "content": "行为"
  }, {
    "heading": "身份验证-authentication",
    "content": "标志"
  }, {
    "heading": "身份验证-authentication",
    "content": "环境变量"
  }, {
    "heading": "身份验证-authentication",
    "content": "turbo.json"
  }, {
    "heading": "身份验证-authentication",
    "content": "登录 URL"
  }, {
    "heading": "身份验证-authentication",
    "content": "*"
  }, {
    "heading": "身份验证-authentication",
    "content": "TURBO_LOGIN"
  }, {
    "heading": "身份验证-authentication",
    "content": "remoteCache.loginUrl"
  }, {
    "heading": "身份验证-authentication",
    "content": "团队名称（用于多团队远程缓存）"
  }, {
    "heading": "身份验证-authentication",
    "content": "--team"
  }, {
    "heading": "身份验证-authentication",
    "content": "TURBO_TEAM"
  }, {
    "heading": "身份验证-authentication",
    "content": "*"
  }, {
    "heading": "身份验证-authentication",
    "content": "团队 ID（用于多团队远程缓存）"
  }, {
    "heading": "身份验证-authentication",
    "content": "*"
  }, {
    "heading": "身份验证-authentication",
    "content": "TURBO_TEAMID"
  }, {
    "heading": "身份验证-authentication",
    "content": "*"
  }, {
    "heading": "身份验证-authentication",
    "content": "身份验证令牌"
  }, {
    "heading": "身份验证-authentication",
    "content": "--token"
  }, {
    "heading": "身份验证-authentication",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "身份验证-authentication",
    "content": "*"
  }, {
    "heading": "其他-other",
    "content": "¥Other"
  }, {
    "heading": "其他-other",
    "content": "行为"
  }, {
    "heading": "其他-other",
    "content": "标志"
  }, {
    "heading": "其他-other",
    "content": "环境变量"
  }, {
    "heading": "其他-other",
    "content": "turbo.json"
  }, {
    "heading": "其他-other",
    "content": "二进制路径"
  }, {
    "heading": "其他-other",
    "content": "*"
  }, {
    "heading": "其他-other",
    "content": "TURBO_BINARY_PATH"
  }, {
    "heading": "其他-other",
    "content": "*"
  }, {
    "heading": "其他-other",
    "content": "下载本地 turbo"
  }, {
    "heading": "其他-other",
    "content": "*"
  }, {
    "heading": "其他-other",
    "content": "TURBO_DOWNLOAD_LOCAL_ENABLED"
  }, {
    "heading": "其他-other",
    "content": "*"
  }, {
    "heading": "其他-other",
    "content": "守护进程"
  }, {
    "heading": "其他-other",
    "content": "--daemon / --no-daemon"
  }, {
    "heading": "其他-other",
    "content": "*"
  }, {
    "heading": "其他-other",
    "content": "daemon"
  }],
  "headings": [{
    "id": "选项表-options-table",
    "content": "选项表 /*options-table*/"
  }, {
    "id": "缓存-caching",
    "content": "缓存 /*caching*/"
  }, {
    "id": "消息-messages",
    "content": "消息 /*messages*/"
  }, {
    "id": "任务运行和日志-task-running-and-logs",
    "content": "任务运行和日志 /*task-running-and-logs*/"
  }, {
    "id": "环境变量-environment-variables",
    "content": "环境变量 /*environment-variables*/"
  }, {
    "id": "调试输出-debugging-outputs",
    "content": "调试输出 /*debugging-outputs*/"
  }, {
    "id": "身份验证-authentication",
    "content": "身份验证 /*authentication*/"
  }, {
    "id": "其他-other",
    "content": "其他 /*other*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#选项表-options-table",
  title: _jsx(_Fragment, {
    children: "选项表 "
  })
}, {
  depth: 3,
  url: "#缓存-caching",
  title: _jsx(_Fragment, {
    children: "缓存 "
  })
}, {
  depth: 3,
  url: "#消息-messages",
  title: _jsx(_Fragment, {
    children: "消息 "
  })
}, {
  depth: 3,
  url: "#任务运行和日志-task-running-and-logs",
  title: _jsx(_Fragment, {
    children: "任务运行和日志 "
  })
}, {
  depth: 3,
  url: "#环境变量-environment-variables",
  title: _jsx(_Fragment, {
    children: "环境变量 "
  })
}, {
  depth: 3,
  url: "#调试输出-debugging-outputs",
  title: _jsx(_Fragment, {
    children: "调试输出 "
  })
}, {
  depth: 3,
  url: "#身份验证-authentication",
  title: _jsx(_Fragment, {
    children: "身份验证 "
  })
}, {
  depth: 3,
  url: "#其他-other",
  title: _jsx(_Fragment, {
    children: "其他 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["有三种方法可以管理 ", _jsx(_components.code, {
        children: "turbo"
      }), " 调用的行为："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There are three ways to manage the behavior of a ", _jsx(_components.code, {
        children: "turbo"
      }), " invocation:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "/docs/reference/configuration",
            children: [_jsx(_components.code, {
              children: "turbo.json"
            }), " 中的配置"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "/docs/reference/configuration",
            children: ["Configuration in ", _jsx(_components.code, {
              children: "turbo.json"
            })]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/system-environment-variables",
            children: "系统环境变量"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/reference/system-environment-variables",
            children: "System Environment Variables"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/run",
            children: "传递给 CLI 调用的标志"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/reference/run",
            children: "Flags passed to the CLI invocation"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["上面列出的三种策略按优先顺序排列。如果提供了标志值，则对于相同的系统环境变量或 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 配置，将使用该标志的值。因此，我们建议使用："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The three strategies listed above are in order of precedence. Where a flag value is provided, for the same System Environment Variable or ", _jsx(_components.code, {
        children: "turbo.json"
      }), " configuration, the value for the flag will be used. Because of this, we recommend using:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), " 默认配置"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo.json"
          }), " configuration for defaults"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "用于每个环境覆盖的系统环境变量"
        }), "\n", _jsx(_components.p, {
          children: "¥System Environment Variables for per-environment overrides"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "每次调用覆盖的标志"
        }), "\n", _jsx(_components.p, {
          children: "¥Flags for per-invocation overrides"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "选项表-options-table",
      children: "选项表 "
    }), "\n", _jsx(_components.p, {
      children: "¥Options table"
    }), "\n", _jsx(_components.h3, {
      id: "缓存-caching",
      children: "缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Caching"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "强制运行任务"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--force",
                children: _jsx(_components.code, {
                  children: "--force"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_force",
                children: _jsx(_components.code, {
                  children: "TURBO_FORCE"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#cache",
                children: _jsx(_components.code, {
                  children: "cache"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "远程缓存超时"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#timeout",
                children: _jsx(_components.code, {
                  children: "--remote-cache-timeout"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_timeout",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_TIMEOUT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#timeout",
                children: _jsx(_components.code, {
                  children: "remoteCache.timeout"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "远程缓存上传超时"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_upload_timeout",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#uploadtimeout",
                children: _jsx(_components.code, {
                  children: "remoteCache.uploadTimeout"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "缓存签名密钥"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_signature_key",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#signature",
                children: _jsx(_components.code, {
                  children: "signature"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "预检请求"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--preflight",
                children: _jsx(_components.code, {
                  children: "--preflight"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_preflight",
                children: _jsx(_components.code, {
                  children: "TURBO_PREFLIGHT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#preflight",
                children: _jsx(_components.code, {
                  children: "remoteCache.preflight"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "远程缓存基准 URL"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_api",
                children: _jsx(_components.code, {
                  children: "TURBO_API"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#remote-caching",
                children: _jsx(_components.code, {
                  children: "remoteCache.apiUrl"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "缓存源"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cache-options",
                children: _jsx(_components.code, {
                  children: "--cache"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_cache",
                children: _jsx(_components.code, {
                  children: "TURBO_CACHE"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "本地缓存目录"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cache-dir-path",
                children: _jsx(_components.code, {
                  children: "--cache-dir"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_cache_dir",
                children: _jsx(_components.code, {
                  children: "TURBO_CACHE_DIR"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#cachedir",
                children: _jsx(_components.code, {
                  children: "cacheDir"
                })
              })
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "消息-messages",
      children: "消息 "
    }), "\n", _jsx(_components.p, {
      children: "¥Messages"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "禁用版本打印"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_print_version_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_PRINT_VERSION_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "禁用遥测消息"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_telemetry_message_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_TELEMETRY_MESSAGE_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["禁用全局 ", _jsx(_components.code, {
                children: "turbo"
              }), " 警告"]
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_global_warning_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_GLOBAL_WARNING_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "不支持更新通知程序"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_no_update_notifier",
                children: _jsx(_components.code, {
                  children: "TURBO_NO_UPDATE_NOTIFIER"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://turbo.nodejs.cn/docs/reference/configuration#noupdatenotifier",
                children: _jsx(_components.code, {
                  children: "noUpdateNotifier"
                })
              })
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "任务运行和日志-task-running-and-logs",
      children: "任务运行和日志 "
    }), "\n", _jsx(_components.p, {
      children: "¥Task running and logs"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "终端 UI"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--ui",
                children: _jsx(_components.code, {
                  children: "--ui"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_ui",
                children: _jsx(_components.code, {
                  children: "TURBO_UI"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#ui",
                children: _jsx(_components.code, {
                  children: "ui"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "运行受影响的任务"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--affected",
                children: _jsx(_components.code, {
                  children: "--affected"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "禁用包管理器检查"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--dangerously-disable-package-manager-check",
                children: _jsx(_components.code, {
                  children: "--dangerously-disable-package-manager-check"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_dangerously_disable_package_manager_check",
                children: _jsx(_components.code, {
                  children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#dangerouslydisablepackagemanagercheck",
                children: _jsx(_components.code, {
                  children: "dangerouslyDisablePackageManagerCheck"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "受影响的基引用"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_scm_base",
                children: _jsx(_components.code, {
                  children: "TURBO_SCM_BASE"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "受影响的头引用"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_scm_head",
                children: _jsx(_components.code, {
                  children: "TURBO_SCM_HEAD"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "仅运行直接指定的任务"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--only",
                children: _jsx(_components.code, {
                  children: "--only"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "任务并发度"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--concurrency-number--percentage",
                children: _jsx(_components.code, {
                  children: "--concurrency"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_concurrency",
                children: _jsx(_components.code, {
                  children: "TURBO_CONCURRENCY"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "任务日志顺序"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--log-order-option",
                children: _jsx(_components.code, {
                  children: "--log-order"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_log_order",
                children: _jsx(_components.code, {
                  children: "TURBO_LOG_ORDER"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "当前工作目录"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cwd-path",
                children: _jsx(_components.code, {
                  children: "--cwd"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "流日志前缀"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--log-prefix-option",
                children: _jsx(_components.code, {
                  children: "--log-prefix"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "任务日志输出级别"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--output-logs-option",
                children: _jsx(_components.code, {
                  children: "--output-logs-option"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#outputlogs",
                children: _jsx(_components.code, {
                  children: "outputLogs"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "全局输入"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--global-deps-file-glob",
                children: _jsx(_components.code, {
                  children: "--global-deps"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#globaldependencies",
                children: _jsx(_components.code, {
                  children: "globalDependencies"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "终端颜色"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference#--color",
                children: _jsx(_components.code, {
                  children: "--color"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#force_color",
                children: "FORCE_COLOR"
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "环境变量-environment-variables",
      children: "环境变量 "
    }), "\n", _jsx(_components.p, {
      children: "¥Environment variables"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "环境变量模式"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--env-mode-option",
                children: _jsx(_components.code, {
                  children: "--env-mode"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#envmode",
                children: _jsx(_components.code, {
                  children: "envMode"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "供应商环境变量"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_ci_vendor_env_key",
                children: _jsx(_components.code, {
                  children: "TURBO_CI_VENDOR_ENV_KEY"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "框架变量异常"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--framework-inference",
                children: _jsx(_components.code, {
                  children: "--framework-inference"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "调试输出-debugging-outputs",
      children: "调试输出 "
    }), "\n", _jsx(_components.p, {
      children: "¥Debugging outputs"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "运行摘要"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--summarize",
                children: _jsx(_components.code, {
                  children: "--summarize"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_run_summary",
                children: _jsx(_components.code, {
                  children: "TURBO_RUN_SUMMARY"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "图形可视化"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--graph-file-name",
                children: _jsx(_components.code, {
                  children: "--graph"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "试运行"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--dry----dry-run",
                children: _jsx(_components.code, {
                  children: "--dry"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: "*"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "身份验证-authentication",
      children: "身份验证 "
    }), "\n", _jsx(_components.p, {
      children: "¥Authentication"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "登录 URL"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_login",
                children: _jsx(_components.code, {
                  children: "TURBO_LOGIN"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#loginurl",
                children: _jsx(_components.code, {
                  children: "remoteCache.loginUrl"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "团队名称（用于多团队远程缓存）"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--team",
                children: _jsx(_components.code, {
                  children: "--team"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_team",
                children: _jsx(_components.code, {
                  children: "TURBO_TEAM"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "团队 ID（用于多团队远程缓存）"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_teamid",
                children: _jsx(_components.code, {
                  children: "TURBO_TEAMID"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "身份验证令牌"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--token",
                children: _jsx(_components.code, {
                  children: "--token"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_token",
                children: _jsx(_components.code, {
                  children: "TURBO_TOKEN"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "其他-other",
      children: "其他 "
    }), "\n", _jsx(_components.p, {
      children: "¥Other"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "行为"
            }), _jsx(_components.th, {
              children: "标志"
            }), _jsx(_components.th, {
              children: "环境变量"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "二进制路径"
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_binary_path",
                children: _jsx(_components.code, {
                  children: "TURBO_BINARY_PATH"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["下载本地 ", _jsx(_components.code, {
                children: "turbo"
              })]
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_download_local_enabled",
                children: _jsx(_components.code, {
                  children: "TURBO_DOWNLOAD_LOCAL_ENABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "*"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "守护进程"
            }), _jsx(_components.td, {
              children: _jsxs(_components.a, {
                href: "/docs/reference/run#--daemon-and---no-daemon",
                children: [_jsx(_components.code, {
                  children: "--daemon"
                }), " / ", _jsx(_components.code, {
                  children: "--no-daemon"
                })]
              })
            }), _jsx(_components.td, {
              children: "*"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#daemon",
                children: _jsx(_components.code, {
                  children: "daemon"
                })
              })
            })]
          })]
        })]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
